import { Components, Theme } from '@mui/material';

const components: Components<Omit<Theme, 'components'>>['MuiPaginationItem'] = {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        borderRadius: '7px',
        boxShadow:
          '0px -2px 8px rgba(3, 6, 13, 0.04), 0px 16px 24px rgba(102, 102, 102, 0.25)'
      }
    }
  }
};

export default { components };
